import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input, TextArea, Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";

import { CardAtividade, Container } from "./styles";
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from "~/services/api";

function AtividadesList({ defaultData, setter, setterSoma, gerarProjeto }) {
  const atividadePad = [
    { item: 1, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Gestão do projeto", descricao: "", horaTotal: 0 },
    { item: 2, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Especificação", descricao: "", horaTotal: 0 },
    { item: 3, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Desenvolvimento/Implementação", descricao: "", horaTotal: 0 },
    { item: 4, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Acompanhamento da Validação Key User/Correções e Ajustes", descricao: "", horaTotal: 0 },
    { item: 5, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Aplicação em Produção/Entrega", descricao: "", horaTotal: 0 },
    { item: 6, id: 0, idDesc: "0 - Sem SD", abertoAtividade: false, titulo: "Acompanhamento pós Entrega", descricao: "", horaTotal: 0 },
  ];
  const [atividades, setAtividades] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aAtividade = [];
          let item = 1;
          for (const itemAtividade of defaultData) {
            aAtividade.push({
              item,
              id: itemAtividade?.id,
              idDesc: item + (itemAtividade?.orcamento ? ` - SD ${itemAtividade?.orcamento?.id}` : ` - Sem SD`),
              titulo: itemAtividade?.titulo,
              descricao: itemAtividade?.descricao,
              horaTotal: itemAtividade?.horaTotal
            });

            item++;
          }
          setAtividades(aAtividade);
          setter(aAtividade);
        }
      } else {
        if (!(edit && editShow)) {
          setAtividades(atividadePad);
          setter(atividadePad);
        }
      }
    }
  }, [edit, editShow]);

  useEffect(() => {
    setter(atividades);

    if (setterSoma) {
      let horaTotal = 0;
      for (const item of atividades) {
        horaTotal += item?.horaTotal;
      }

      setterSoma(horaTotal);
    }
  }, [atividades]);

  function handleAddAtividade() {
    setAtividades((prev) => [...prev, { item: (atividades?.length > 0 ? atividades[atividades?.length - 1]?.item + 1 : 1), id: 0, abertoAtividade: false, idDesc: "0 - Sem SD", titulo: "Atividade de Projeto", descricao: "", horaTotal: 0 }]);
  }

  function handleRemoveAtividade(data) {
    setAtividades((prev) => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex((e) => e?.item === data?.item);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Atividades *" className="titulo-label" row={true}>
        {!(editShow && edit) ? (
          <ColoredButton small blueLayout type="button" onClick={handleAddAtividade}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )}
      </Label>
      <CardAtividade>
        <div className="card-atv-header">
          <div className="titulos-tab">
            <div className="w1">
              <div className="top-header">
                -
              </div>
            </div>
            <div className="atividade">
              <p className="titulo">Título <span>*</span></p>
            </div>
            <div className="hora-total">
              <p className="titulo">Hora Total <span>*</span></p>
            </div>
            <div className="desc">
              <p className="titulo">Escopo</p>
            </div>
          </div>
        </div>
        {atividades?.map((itemData, index) => (
          <div className="card-atv-body">
            <div className="row no-margin row-top">
              <div className="w1">
                <div className="top-header">
                  <div onClick={(e) => { handleRemoveAtividade(itemData) }} className="icon-button material-icons">delete</div>
                </div>
              </div>
              <div className="w2">
                <Input
                  placeholder="Titulo da Atividade"
                  name="tituloAtividadeAt"
                  required="true"
                  value={itemData?.titulo}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].titulo = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w3">
                <Input
                  type="number"
                  name="horaTotalAt"
                  required="true"
                  value={itemData?.horaTotal}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].horaTotal = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="w5">
                <TextArea
                  placeholder="Escopo"
                  name="descAtividadeAt"
                  value={itemData?.descricao}
                  onChange={(e) => {
                    const v = e.currentTarget.value || "";
                    setAtividades((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].descricao = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </CardAtividade>
      {/* ))} */}
    </Container>
  );
}

export default AtividadesList;
